import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KitchenMosterService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/kitchenmaster";

  newkitchenMaster(kitchenMaster: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, kitchenMaster)
  }

  kitchenMaster(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllkitchenMasterDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  kitchenMasterSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByKitchenMasterId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  downloadKitchenMasterTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  downloadCutterMasterReport(Page: number, size: number, sort, selectionCutterMaster): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionCutterMaster, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  getWarehouseByKitchenId(id: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown/${id}`);
  }
}